export enum Level {
  beginner,
  intermediate,
  advanced
}
